// extracted by mini-css-extract-plugin
export default {"wrapper":"EditTable_wrapper__bWDQo","tabWrapper":"EditTable_tabWrapper__6P0OV","tab":"EditTable_tab__5AVRb","selected":"EditTable_selected__5TquE"};